import { useQueries } from "@tanstack/react-query";
import { omnimizerApi, omnimizerKeys } from "./api";
import { deploymentState } from "./state";
import type { ObservabilityResponse, OmnimizerDeployment, WorkerMetrics } from "./types";
type MetricKey = keyof WorkerMetrics;
export const OBSERVABILITY_POLL_MS = 30000;
const FLEET_LIMIT = 12;
// Absent samples stay absent instead of becoming zero.
export function sumMetrics(samples: (ObservabilityResponse | undefined)[]) {
  const total: Record<MetricKey, number | null> = {
    output_tokens_per_second: null,
    input_tokens_per_second: null,
    requests_per_second: null,
    running: null,
    queued: null,
  };
  for (const sample of samples) {
    if (!sample?.available) continue;
    for (const key of Object.keys(total) as MetricKey[]) {
      const value = sample.metrics[key];
      if (value != null && Number.isFinite(value)) total[key] = (total[key] ?? 0) + value;
    }
  }
  return total;
}

export function useFleetObservability(deployments: OmnimizerDeployment[], paused = false) {
  const live = deployments
    .filter((d) => d.is_active && deploymentState(d) === "ready")
    .slice(0, FLEET_LIMIT);
  const queries = useQueries({
    queries: live.map((d) => ({
      queryKey: omnimizerKeys.observability(d.model_id, d.version, 1),
      queryFn: () => omnimizerApi.observability(d, 1),
      refetchInterval: paused ? (false as const) : OBSERVABILITY_POLL_MS,
      retry: false,
    })),
  });
  return live.map((d, i) => ({ deployment: d, query: queries[i] }));
}


export type FleetObservability = ReturnType<typeof useFleetObservability>;
